import { render, staticRenderFns } from "./FileRemoveIcon.vue?vue&type=template&id=35cced83&scoped=true&"
import script from "./FileRemoveIcon.vue?vue&type=script&lang=js&"
export * from "./FileRemoveIcon.vue?vue&type=script&lang=js&"
import style0 from "./FileRemoveIcon.vue?vue&type=style&index=0&id=35cced83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cced83",
  null
  
)

export default component.exports